import Particles, { initParticlesEngine } from '@tsparticles/react';
import { useEffect, useMemo, useState } from 'react';
import { loadSlim } from '@tsparticles/slim';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';

const ParticlesComponent = ({ id, style }) => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    if (!init) {
      initParticlesEngine(async (engine) => {
        await loadSlim(engine);
      }).then(() => {
        setInit(true);
      });
    }
  }, [init]);

  const particlesLoaded = (container) => {
    console.log(container);
  };

  const theme = useTheme();

  const options = useMemo(() => ({
    background: {
      color: { value: '#ffffff' },
    },
    fpsLimit: 120,
    interactivity: {
      events: {
        onClick: { enable: true, mode: 'repulse' },
        onHover: { enable: true, mode: 'grab' },
      },
      modes: {
        push: { distance: 200, duration: 15 },
        grab: { distance: 150 },
      },
    },
    particles: {
      color: { value: '#81b6ee' },
      links: {
        color: { value: '#81b6ee' },
        distance: 150,
        enable: true,
        width: 1,
      },
      move: {
        direction: 'none',
        enable: true,
        outModes: { default: 'bounce' },
        random: true,
        speed: 1,
        straight: false,
      },
      number: { density: { enable: true }, value: 150 },
      opacity: { value: 1 },
      shape: { type: 'circle' },
      size: { value: { min: 2, max: 5 } },
    },
    detectRetina: false,
  }), []);

  return (
    <Particles
      id={id}
      style={style}
      init={particlesLoaded}
      options={options}
    />
  );
};

ParticlesComponent.propTypes = {
  id: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default ParticlesComponent;
